module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-cards__view_section\">\n	<div class=\"title\">\n		<b>История исполнения</b>\n	</div>\n	<div>\n		<table class=\"table\">\n			<tr class=\"title\">\n				<td><b>Дата/Время</b></td>\n				<td><b>Название</b></td>\n				<td><b>Статус</b></td>\n				<td><b>Пользователь</b></td>\n			</tr>\n			")
    ;  Util.each(history, function (item) { 
    ; __append("\n			")
    ;  var statusEnum = recipientStatus[item.assignment.recipientclass]; 
    ; __append("\n			<tr>\n				<td>")
    ; __append(escapeFn( item.datetime ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( item.assignment.recipientname ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( statusEnum ? statusEnum.title(item.status) : item.statusName ))
    ; __append("</td>\n				<td>\n					")
    ; __append(escapeFn( Glonass.TrackableHistory.initiator(item) ))
    ; __append("\n				</td>\n			</tr>\n			")
    ;  }); 
    ; __append("\n		</table>\n	</div>\n</div>\n")
  }
  return __output.join("");

}